import { Scenario } from 'routes/Scenarios/Scenario/Scenario'
import {
  fetchAllScenarios,
  fetchSingleScenario,
} from 'routes/Scenarios/helpers'
import {
  ScenarioTemplateCompact,
  ScenarioTemplateExtended,
} from 'routes/Scenarios/helpers/types'

export default function ScenarioPage({
  scenario,
  scenarioTemplates,
}: {
  scenario: ScenarioTemplateExtended
  scenarioTemplates: ScenarioTemplateCompact[]
}) {
  if (!scenario) return null
  return <Scenario scenario={scenario} scenarioTemplates={scenarioTemplates} />
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: true,
  }
}

export async function getStaticProps({ params }) {
  const scenarioKey = params.scenarioKey

  const scenario = await fetchSingleScenario(scenarioKey)

  const scenarioTemplates = await fetchAllScenarios()

  return { props: { scenario, scenarioTemplates } }
}
